import React, { ReactNode, useEffect, useMemo } from 'react'
import { ScrollView, View, ViewStyle } from 'react-native'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'
import Loading from '../Loading'
import { useResponsive } from '../../utils/hooks'

type Props = {
  children: ReactNode
  toolbar?: ReactNode
  containerStyle?: ViewStyle
  contentContainerStyle?: ViewStyle
  toTopScroller?: boolean | string
  loading?: boolean
  onLayout?: (e) => void
  footer?: ReactNode
}

export default ({
  children,
  toolbar,
  containerStyle,
  contentContainerStyle,
  toTopScroller = true,
  loading = false,
  onLayout,
  footer,
}: Props) => {
  const { mobileWidth, sm } = useResponsive()
  const backgroundColor = contentContainerStyle?.backgroundColor || 'white'
  let scrollView

  const width = mobileWidth

  const header = useMemo(() => {
    if (!toolbar) return null
    return <View style={{ width: '100%', backgroundColor }}>{toolbar}</View>
  }, [backgroundColor, toolbar])

  useEffect(() => {
    if (scrollView) {
      scrollView.scrollTo({ x: 0, y: 0, animated: true })
    } else {
      window.scrollTo(0, 0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toTopScroller])

  const content = loading ? <Loading /> : children
  return (
    <View
      style={composeStyle(
        {
          backgroundColor: 'white',
          flex: 1,
        },
        containerStyle,
      )}
    >
      <View style={{ width }}>{header}</View>
      <ScrollView
        contentContainerStyle={composeStyle(
          {
            width: '100%',
            flex: 1,
          },
          contentContainerStyle,
        )}
        ref={(r) => (scrollView = r)}
        showsVerticalScrollIndicator={false}
        onLayout={onLayout}
      >
        <View style={composeStyle(sm && { width }, { paddingHorizontal: 16 })}>
          {content}
        </View>
      </ScrollView>
      <View style={{ width }}>{footer}</View>
    </View>
  )
}
